if (!customElements.get('product-content')) {
  customElements.define('product-content', class ProductContent extends HTMLElement {
    constructor() {
      super();

      this.productInfoWraper = document.querySelector('.product__info-wrapper');

      const parent = this.parentElement;
      const previousElement = parent ? parent.previousSibling : null;
      const followsProductPageSection = previousElement ? previousElement.classList.contains('product-page-section') : false;

      if (this.productInfoWraper && followsProductPageSection) {
        this.productPageSection = previousElement;
        $('.product-section').wrapAll('<div class="product-section-main-wrap" />');
      } else if (this.productInfoWraper && !followsProductPageSection) {
        const productPageSection = document.querySelector('.product-page-section');
        if (productPageSection) {
          productPageSection.classList.add('product-static-buy-tools');
        }
      }

      this.handleCollapsibleBlocks();
    }

    removeProductInfoHeight() {
      this.productInfoWraper.style.height = "";
    }

    handleCollapsibleBlocks() {
      const details = this.querySelectorAll('.product__collapsible-details');
      const RO = new ResizeObserver(entries => {
        return entries.forEach(entry => {
          const detail = entry.target;
          const detailWidth = +detail.dataset.width;
          const roundedEntrySize = Math.round(entry.contentRect.width);
          if (detailWidth !== roundedEntrySize) {
            detail.removeAttribute('style');
            this.setHeight(detail);
          }
        })
      });

      details.forEach(detail => {
        RO.observe(detail);
      });
    }

    setHeight (detail) {
      detail.open = true;
      const rectOpen = detail.getBoundingClientRect();
      detail.style.setProperty('--expanded', `${rectOpen.height}px`);

      detail.open = false;
      const rectClose = detail.getBoundingClientRect();
      detail.style.setProperty('--collapsed', `${rectClose.height}px`);
      detail.dataset.width = Math.round(rectClose.width);
    }
  });
}
